package com.evoapps.evoshift.domain.usecase.daily

import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.repository.FinancialRepository
import com.evoapps.evoshift.domain.usecase.finance.CalculateDailyRecordUseCase

/**
 * SH-76: once a month exists, one day's planned revenue (net) can differ from its weekday's sales
 * target (a holiday, an event nearby). The day is recomputed with the new target, so its planned
 * labour % follows; the takings, the comments and the lock are kept. `null` goes back to the
 * weekday's target. A closed day is final ([com.evoapps.evoshift.domain.model.DayClosedException]).
 */
class UpdateDailyTargetUseCase(
    private val financialRepository: FinancialRepository,
    private val calculateDailyRecordUseCase: CalculateDailyRecordUseCase
) {
    suspend operator fun invoke(workplaceId: String, rosterId: String, date: String, target: Double?): Result<DailyRecord> = runCatching {
        require(target == null || target >= 0.0) { "A target cannot be negative" }
        val record = calculateDailyRecordUseCase.recompute(workplaceId, rosterId, date) { it.copy(planNetto = target) }.getOrThrow()
        financialRepository.saveDailyRecord(record).getOrThrow()
        record
    }
}
